export default __webpack_public_path__ + "img/b2532cd347d0e579afde50738721412f.png";